// Third Party
import React, { Component } from 'react';

// Components
import DataTable from '../../components/data/DataTable';
import { IntegerValue } from '../../components/common';
import { Tooltip } from '../../components/tooltips';

// Utils
import { formatMessage, formatLocalizedString } from '../../../utils/i18n';
import MostSearchedFund from '@/types/most-searched-fund';
import LocalizedString from '@/types/localized-string';

type Props = {
  items: MostSearchedFund[];
};

class MostSearchedFunds extends Component<Props> {
  getFundColumns = () => [
    {
      Header: formatMessage('Insights.MostSearchedFunds.Table.Code'),
      accessor: 'data.symbols',
      className: 'fund-symbol',
      width: 80,
      includeInCompact: true,
      Cell: ({ value }: { value: string[] }) => <span>{value && value.length ? value[0] : ''}</span>,
    },
    {
      Header: formatMessage('Insights.MostSearchedFunds.Table.Name'),
      accessor: 'data.names.full',
      className: 'fund-name',
      minWidth: 100,
      includeInCompact: true,
      Cell: ({ value }: { value: LocalizedString }) => {
        const valueString = formatLocalizedString(value);
        return (
          <Tooltip message={valueString} delayShow={300}>
            <span>{valueString}</span>
          </Tooltip>
        );
      },
    },
    // TODO -- CON-1649 // Re-add this column once the 1D data gets parsed
    // {
    //   Header: formatMessage('Insights.MostSearchedFunds.Table.1D'),
    //   headerClassName: 'fund-percent-growth',
    //   className: 'fund-percent-growth',
    //   accessor: 'data.percentGrowth.1D',
    //   Cell: ({ value }: { value: number }) => <IntegerValue value={value} growth isPercentage />,
    //   width: 70,
    // },
    {
      Header: formatMessage('Insights.MostSearchedFunds.Table.YT'),
      headerClassName: 'fund-percent-growth',
      className: 'fund-percent-growth',
      accessor: 'data.percentGrowth.YT',
      Cell: ({ value }: { value: number }) => <IntegerValue value={value} growth isPercentage />,
      includeInCompact: true,
      width: 80,
    },
  ];

  render() {
    const { items } = this.props;

    return (
      <DataTable
        className="most-searched-funds"
        columns={this.getFundColumns()}
        data={items}
        selectOnRowClick={false}
        noDataText={formatMessage('Insights.MostSearchedFunds.Table.NoData')}
      />
    );
  }
}

export default MostSearchedFunds;
